var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpload = function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.788 12.974a.626.626 0 0 1 0-.884l2.906-2.907a.626.626 0 0 1 .786-.08l.098.08 2.907 2.907a.626.626 0 0 1-.884.884l-1.838-1.839v5.596a.626.626 0 0 1-1.25 0v-5.598l-1.841 1.84a.625.625 0 0 1-.884 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.25,
    d: "M16.782 12.874A4 4 0 0 0 14 6l-.126.003a4.001 4.001 0 0 0-7.749 0Q6.063 6 6 6a4 4 0 0 0-2.782 6.874"
  })));
};
export default SvgUpload;